import React from 'react';

export default function PageLoader() {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '80px 0' }}>
      <div style={{
        width: 28,
        height: 28,
        border: '3px solid #e5e7eb',
        borderTopColor: '#00bf62',
        borderRadius: '50%',
        animation: 'pageLoaderSpin 0.7s linear infinite',
      }} />
      <style>{`@keyframes pageLoaderSpin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}
